const learnSkills = {
  skills: '/module/',
  lessonBySkillId: (id) => `/module/${id}/pages/`,
  lessonDetail: (lessonId) => `/module/${lessonId}/getTopicInfo/`,
  lessonInfoIsHelpful: (lessonId) => `/module/${lessonId}/topicHelpful/`,
  lessonMarkAsComplete: (lessonId) => `/module/${lessonId}/topicViewed/`,
  lessonvideoisViewed: (lessonId) => `/module/${lessonId}/videoWatched/`,
};

const activeModules = {
  modules: (childId) => `/child/${childId}/getAllModulesValues/`,
  activateModules: (childId) => `/child/${childId}/setModulesValue/`,
};

const manageClasses = {
  createClass: `/subject/`,
  updateClasses: `/subject/updateSubjects/`,
  classes: (childId) => `/child/${childId}/getClasses/`,
  deleteClass: (classId) => `/subject/${classId}/`,
};

const surveys = {
  getSurveys: `/surveys/`,
};
export { learnSkills, activeModules, manageClasses, surveys };
